import { ReactNode } from "react";
import { SyntheticListenerMap } from "@dnd-kit/core/dist/hooks/utilities";
import { DraggableAttributes } from "@dnd-kit/core";

import DraggableItemHandle from "ds/components/DraggableItem/Handle";
import CardHeader from "ds/components/Card/components/Header";
import CardWrapper from "ds/components/Card/components/Wrapper";
import CardContent from "ds/components/Card/components/Content";
import { ColumnId } from "components/DragDropList/types";

import { Widget } from "./types";
import DashboardItemTitle from "./ItemTitle";

type DashboardCardProps = {
  children?: ReactNode;
  dragging?: boolean;
  handleListeners?: SyntheticListenerMap;
  handleAttributes?: DraggableAttributes;
  handleRef?: React.ForwardedRef<HTMLDivElement>;
  titleComponent?: ReactNode;
  disabled?: boolean;
  columnId?: ColumnId;
  id: Widget;
  title: string;
  infoTooltip?: string;
  hideItem: (columnId: ColumnId, id: Widget) => void;
};

const DashboardCard = ({
  children,
  dragging,
  handleRef,
  handleListeners,
  handleAttributes,
  columnId,
  id,
  hideItem,
  title,
  infoTooltip,
  disabled,
}: DashboardCardProps) => {
  return (
    <CardWrapper justify="between" fullWidth>
      <CardHeader
        prefix={
          <DraggableItemHandle
            dragging={dragging}
            variant="p-t6"
            ref={handleRef}
            handleListeners={handleListeners}
            handleAttributes={handleAttributes}
            disabled={disabled}
          />
        }
      >
        <DashboardItemTitle
          title={title}
          infoTooltip={infoTooltip}
          onHide={columnId ? () => hideItem(columnId, id as Widget) : undefined}
        />
      </CardHeader>
      <CardContent hasHeader fullWidth>
        {children}
      </CardContent>
    </CardWrapper>
  );
};

export default DashboardCard;
